<nav
  id="main-nav"
  class="navbar navbar-dark bg-primary navbar-expand-lg navbar-link-underline"
  aria-label="Site"
>
  <div class="container-fluid flex-nowrap">
    <button class="navbar-toggler" type="button" (click)="openMainNav(offcanvasMainNav)">
      <span class="material-symbols-rounded icon-lg" aria-hidden="true">menu</span>
      <span class="visually-hidden">Menu</span>
    </button>
    <a class="navbar-brand navbar-logo mx-auto ms-lg-0" routerLink="/home">
      <img src="logo-appname-white.svg" alt="{{ appName }}" />
    </a>

    <ul class="navbar-nav mx-auto d-none d-lg-flex">
      @for (item of mainNav; track item.path) {
        <li class="nav-item">
          <a
            class="nav-link"
            [routerLink]="item.path"
            routerLinkActive="active"
            [ariaCurrentWhenActive]="'page'"
            [attr.data-label]="item.label"
          >
            <span class="nav-link-label">{{ item.label }}</span>
          </a>
        </li>
      }
    </ul>

    <ul class="navbar-nav flex-row ms-lg-auto ms-2 me-n2">
      <li class="nav-item d-flex align-items-center me-2 me-lg-3">
        <button
          type="button"
          class="nav-link no-caret fw-normal py-0 d-flex align-items-center text-nowrap"
          (click)="openHowItWorks(howItWorksModal)"
        >
          <span class="material-symbols-rounded icon-lg align-middle" aria-hidden="true">help</span>
          <span class="d-none d-lg-inline ms-1">How It Works</span>
          <span class="visually-hidden d-lg-none">How It Works</span>
        </button>
      </li>
      <li ngbDropdown class="nav-item">
        <!-- Mobile -->
        <button
          type="button"
          class="nav-link no-caret fw-normal d-lg-none py-0"
          id="userAccountDropdown"
          (click)="openUserNav(offcanvasUserNav)"
        >
          <span class="material-symbols-rounded icon-lg" aria-hidden="true">account_circle</span>
          <span class="visually-hidden">
            User settings for {{ displayName() }}
          </span>
        </button>
        <!-- Desktop -->
        <button class="nav-link d-none d-lg-inline-block px-0 py-2" ngbDropdownToggle>
          <span class="badge badge-username" aria-hidden="true">
            {{ userInitials() }}
          </span>
          <span class="nav-link-wrapper" [attr.data-label]="displayName()">
            <span class="visually-hidden">User settings for </span>
            <span class="nav-link-label">{{ displayName() }}</span>
          </span>
        </button>
        <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-end position-absolute">
          @for (item of userNav; track item.label) {
            <li>
              <a [routerLink]="item.path" ngbDropdownItem>{{ item.label }}</a>
            </li>
          }
          <li><hr class="dropdown-divider" /></li>
          <li>
            <button type="button" ngbDropdownItem (click)="signOut()">Sign Out</button>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>

<!-- Offcanvas: Main Menu -->
<ng-template #offcanvasMainNav let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title" id="offcanvas-main-nav" ngbAutofocus tabindex="-1">Navigation</h4>
    <button
      type="button"
      class="btn-close btn-close-white"
      aria-label="Close"
      (click)="offcanvas.dismiss('Cross click')"
    ></button>
  </div>
  <div class="offcanvas-body m-0 p-0">
    <lc-sidebar
      [sidebar-dark]="true"
      [navItems]="mainNav"
      (linkClicked)="offcanvas.dismiss('Navigation')"
    />
  </div>
</ng-template>

<!-- Offcanvas: UserNav -->
<ng-template #offcanvasUserNav let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title" id="offcanvas-user-nav" ngbAutofocus tabindex="-1">
      {{ displayName() }}
    </h4>
    <button
      type="button"
      class="btn-close btn-close-white"
      aria-label="Close"
      (click)="offcanvas.dismiss('Cross click')"
    ></button>
  </div>
  <div class="offcanvas-body m-0 p-0">
    <lc-sidebar
      [sidebar-dark]="true"
      [navItems]="userNav"
      (linkClicked)="offcanvas.dismiss('Navigation')"
    />
    <hr class="mx-3" />
    <button type="button" class="btn btn-link text-white px-3" (click)="signOut()">
      Sign Out
    </button>
  </div>
</ng-template>

<!-- Modal: How It Works -->
<ng-template #howItWorksModal let-modal>
  <div class="modal-header">
    <h2 id="how-it-works-title" class="modal-title flex-fill text-center" ngbAutofocus tabindex="-1">
      How It Works
    </h2>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <ul class="list-group list-group-flush">
      @for (step of howItWorksSteps; track step.id) {
        <li class="list-group-item d-flex align-items-start gap-3 py-3">
          <span
            class="step-icon d-inline-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary flex-shrink-0"
          >
            <span class="material-symbols-rounded" aria-hidden="true">{{ step.icon }}</span>
          </span>
          <div>
            <p class="fw-semibold mb-1">{{ step.label }}</p>
            <p class="text-muted small mb-0">{{ step.description }}</p>
          </div>
        </li>
      }
    </ul>
  </div>
</ng-template>
